import React from "react";
import { NavLink } from "react-router-dom";
import { Button, Card, Header, List } from "semantic-ui-react";

import IParishMin from "../../../data/parish/ParishMin";
import IMainPlacement from "../../../data/priest/MainPlacement";
import "../../../static/priestProfile.css";
import CardRow from "../CardRow";
import CardRowForDate from "../CardRowForDate";
import CardRowPlacementDropDown from "./CardRowPlacementDropDown";

interface IMainPlacementCardProps {
    placement: IMainPlacement;
    index: number;
    editMode: boolean;
    handleDeletePlacement: (index: number) => void;
    handleChangeOnPlacementField: (labelName: string, value: any, index: number) => void;
    handlePlacementChange: (placeID: number, place: string, index: number) => void;
    parishResponse: IParishMin[] | undefined;
    parishLoading: boolean;
    parishShowError: boolean;
}

const MainPlacementCard: React.FC<IMainPlacementCardProps> = (props: IMainPlacementCardProps) => {
    const {
        placement,
        index,
        editMode,
        handleDeletePlacement,
        handleChangeOnPlacementField,
        handlePlacementChange,
        parishResponse,
        parishLoading,
        parishShowError
    } = props;

    const editHandlers = {
        index,
        editMode,
        setValue: handleChangeOnPlacementField
    };

    const handleDeletePressed = () => {
        handleDeletePlacement(index);
    };

    const getCardContent = () => {
        return (
            <Card.Content>
                <Card.Content>
                    {editMode ? (
                        <Button color="red" floated="right" icon="trash" id="deleteButton" inverted onClick={handleDeletePressed} />
                    ) : (
                        <Card.Header id="header">
                            <Header as="h2">{placement.place}</Header>
                        </Card.Header>
                    )}
                </Card.Content>

                <Card.Description>
                    <List>
                        {editMode && (
                            <List.Item>
                                <CardRowPlacementDropDown
                                    editMode={editMode}
                                    handlePlacementChange={handlePlacementChange}
                                    index={index}
                                    parishLoading={parishLoading}
                                    parishResponse={parishResponse}
                                    parishShowError={parishShowError}
                                    placeID={placement.placeID}
                                    placeName={placement.place}
                                />
                            </List.Item>
                        )}
                        <List.Item>
                            <CardRowForDate data={placement.startDate} labelName="startDate" {...editHandlers} />
                        </List.Item>
                        <List.Item>
                            <CardRowForDate data={placement.endDate} labelName="endDate" {...editHandlers} />
                        </List.Item>
                        <List.Item>
                            <CardRow data={placement.numberOfPeople} labelName="numberOfPeople" {...editHandlers} />
                        </List.Item>
                        <List.Item>
                            <CardRow data={placement.munimentIssuingAuthority} labelName="munimentIssuingAuthority" {...editHandlers} />
                        </List.Item>
                        <List.Item>
                            <CardRowForDate data={placement.munimentGenesisDate} labelName="munimentGenesisDate" {...editHandlers} />
                        </List.Item>
                        <List.Item>
                            <CardRow data={placement.munimentNumber} labelName="munimentNumber" {...editHandlers} />
                        </List.Item>
                        <List.Item>
                            <CardRow data={placement.income} labelName="income" {...editHandlers} />
                        </List.Item>
                    </List>
                </Card.Description>
            </Card.Content>
        );
    };

    if (editMode) {
        return <Card fluid>{getCardContent()}</Card>;
    } else {
        return (
            <Card as={NavLink} fluid to={`/parishes/profile/${placement.placeID}`}>
                {getCardContent()}
            </Card>
        );
    }
};

export default MainPlacementCard;
